// extracted by mini-css-extract-plugin
module.exports = {"cp-modal-course__preview":"styles_cp-modal-course__preview__2F1Pn","cp-modal-course__cert__preview":"styles_cp-modal-course__cert__preview__3hZSM","editor":"styles_editor__2qyIN"};